import { createGlobalStyle } from 'styled-components';
import TikTokRegularTtf from '../../assets/fonts/TikTokFont-Regular.ttf';
export const TikTokTextFont = createGlobalStyle`
  @font-face {
    font-family: 'TikTok Text';
    src: url(${TikTokRegularTtf}) format('truetype');
  }
  html *,
  body * {
    font-family: 'TikTok Text', sans-serif;
  }
`;
